export const SORT_KEY_PAIR = "pair";
export const SORT_KEY_PRICE = "price";
export const SORT_KEY_CHANGE = "change";
export const SORT_KEY_MARKET_CAP = "marketCap";
export const SORT_KEY_VOLUME = "volume";

export const SORT_DIRECTION_ASC = "asc";

const NUMERIC_SORT_FIELDS = {
  [SORT_KEY_PRICE]: "current_price",
  [SORT_KEY_CHANGE]: "price_change_percentage_24h",
  [SORT_KEY_MARKET_CAP]: "market_cap",
  [SORT_KEY_VOLUME]: "total_volume",
};

const MISSING_NUMERIC_VALUE = 0;

const getNumericValue = (coin, field) => coin[field] ?? MISSING_NUMERIC_VALUE;

const getSymbol = (coin) => (coin.symbol || "").toLowerCase();

const sortCoins = (coins, sortBy, sortDirection) => {
  if (!sortBy) {
    return coins;
  }

  const direction = sortDirection === SORT_DIRECTION_ASC ? 1 : -1;
  const numericField = NUMERIC_SORT_FIELDS[sortBy];

  return [...coins].sort((a, b) => {
    if (sortBy === SORT_KEY_PAIR) {
      return direction * getSymbol(a).localeCompare(getSymbol(b));
    }

    if (!numericField) {
      return 0;
    }

    const aValue = getNumericValue(a, numericField);
    const bValue = getNumericValue(b, numericField);

    if (aValue === bValue) return 0;
    return aValue > bValue ? direction : -direction;
  });
};

export default sortCoins;
